<template>
  <div id="pano" />
</template>

<script>
import { scenicList } from "@/api/scenic";
import { getMusic } from "@/api/config";

export default {
  name: "KraPano",
  data() {
    return {
      krpano: null,
      list: null,
      music: null,
    };
  },
  mounted() {
    this.getList();
  },

  destroyed() {
    this.krpano.call(`playsound(bg, '' , 0)`);
  },
  methods: {
    getList() {
      scenicList().then((ret) => {
        this.list = ret;
        getMusic()
          .then((ret) => {
            this.music = ret.value;
          })
          .then(() => {
            this.initKrpano();
          });
      });
    },

    initKrpano() {
      embedpano({
        target: "pano",
        xml: "https://anli.yyttww.com/wfz/home/home.xml",
        onready: (krpano_interface) => {
          this.krpano_onready_callback(krpano_interface);
        },
      });
    },

    krpano_onready_callback(krpano_interface) {
      this.krpano = krpano_interface.get("global");
      this.krpano.set("events[dm].keep", true);

      var style = "";
      for (var i = 0; i <= this.list.length; i++) {
        var str =
          '<style name="host_icon_' +
          i +
          '" url="' +
          this.list[i]?.icon +
          '"  afu="false" scale="1" align="center" oy="0" width="30" height="117" framewidth="30" frameheight="117" framemax="24" frame="0" />';
        style += str.replace(new RegExp(" scoped"), "");
      }

      var xml = `<krpano version="1.20.9" title="Virtual Tour">
							${style}
					      </krpano>`;

      this.krpano.call(`loadxml(${xml})`);
      this.krpano.call(`playsound(bg,  ${this.music} , 0)`);
      this.krpano.call(`loadscene(scene_home);`);
      this.krpano.set("events[dm].onnewscene", this.onnewscene);
    },
    onnewscene() {
      this.list.map((hot, index) => {
        this.addhotspot(hot, index);
      });
    },

    addhotspot(hotspot, index) {
      this.krpano.call(`addhotspot(hotspot_${hotspot.id});`);
      const kr_hotspot = this.krpano.get(`hotspot[hotspot_${hotspot.id}]`);
      kr_hotspot.ath = hotspot.ath;
      kr_hotspot.atv = hotspot.atv;
      kr_hotspot.loadstyle("host_icon_" + index);

      kr_hotspot.onclick = () => {
        if (hotspot.three_link) {
          this.$router.push({
            path: "/pano",
            query: {
              id: hotspot.id,
            }
          });
        }
      };
    },
  },
};
</script>

<style lang="scss">
#pano {
  width: 100%;
  height: 100%;
}
</style>
